export enum ExperienceLevel {
  NEVER_STRETCHED = 1,
  STARTED_RECENTLY = 2,
  NOT_REGULARLY = 3,
  REGULARLY_6_MONTH = 4,
  REGULARLY_OVER_YEAR = 5,
}
